import {Tooltip,OverlayTrigger} from 'react-bootstrap';

const Tooltipcomponent=({child,title})=>{
  const renderTooltip = (props) =><Tooltip id="button-tooltip" {...props}>{title}</Tooltip>;
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      {child}
    </OverlayTrigger>
  );
}

export default Tooltipcomponent;